import React, { Component } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { toastr } from "react-redux-toastr";
import Layout from "components/Layout";
import moment from "moment";
import { Button, ButtonGroup, FormGroup, Dropdown } from "react-bootstrap";
import {
	FiPlus,
	FiExternalLink,
	FiMoreHorizontal,
	FiDownload,
	FiUpload,
	FiList,
	FiGrid,
} from "react-icons/fi";
import Loading from "components/Loading";
import PendingAbsences from "components/Absences/PendingAbsences";
import AbsenceEditModal from "components/Absences/AbsenceEditModal";
import AbsenceAnswerModal from "components/Absences/AbsenceAnswerModal";
import { showModal, hideModal, updateModalLoading } from "actions/modalActions";
import * as workflowsActions from "actions/workflowsActions";
import * as employeesActions from "actions/employeesActions";
import * as shiftsActions from "actions/shiftsActions";
import { workflowsService, appService } from "services";
import { wfStatus } from "services/workflowsService";
import { shiftTypeQuery } from "services/shiftsService";
import Modal from "components/Modal";
import "react-dates/lib/css/_datepicker.css";
import "react-dates/initialize";
import { DateRangePicker } from "react-dates";
import { helpUrls } from "utils/helpUrls";
import InfiniteScroll from "react-infinite-scroll-component";
import Switch from "components/Switch";
import { isAdmin, isSupervisor } from "utils/utils";
import EmployeeSelectSearch from "components/EmployeeSelectSearch/EmployeeSelectSearch";

class AbsencesPending extends Component {
	constructor(props) {
		super(props);
		// console.log(props);
		this.closeModal = this.closeModal.bind(this);
		this.openNewAbsenceModal = this.openNewAbsenceModal.bind(this);
		this.openEditAbsenceModal = this.openEditAbsenceModal.bind(this);
		this.openAlertModal = this.openAlertModal.bind(this);
		this.handleCancelRequest = this.handleCancelRequest.bind(this);
		this.employeeSelectFetchOptions = {};

		this.state = {
			focusedInput: null,
			employee_id: -1,
			isSubmit: false,
			is_list_view: false,
			isLoading: false,
			page: 0,
			page_size: 20,
			pending_absences: [],
			hasMore: true,
			include_all_company: false,
		};
	}

	async componentDidMount() {
		// TODO revisar
		var contract_absence_shifts = true;
		contract_absence_shifts = false;
		await this.getPendingAbsences();

		await this.props.getAbsenceShifts({
			shift_type: shiftTypeQuery.absence,
			contract_only: contract_absence_shifts,
		});
	}

	handleChangeView = (is_list_view) => {
		this.setState({
			is_list_view,
		});
	};

	fetchMoreData = () => {
		const { page } = this.state;
		this.setState(
			{
				page: page + 1,
			},
			() => {
				this.getPendingAbsences();
			}
		);
	};

	async getPendingAbsences() {
		this.setState({
			isLoading: this.state.page === 0,
		});

		const {
			start_from,
			start_to,
			employee_id,
			page,
			page_size,
			pending_absences,
			include_all_company,
		} = this.state;

		try {
			const options = { start_from, start_to, employee_id, page, page_size };
			if (isAdmin() && isSupervisor()) {
				options.include_all_company = include_all_company;
			}
			const response = await workflowsService.getPendingAbsences(options);

			let new_absences = [];
			let total_items = 0;

			if (response.data) {
				new_absences = response.data;
				if (response.pagination && response.pagination.total_items) {
					total_items = response.pagination.total_items;
				} else if (response.total) {
					total_items = response.total;
				}
			} else if (Array.isArray(response)) {
				new_absences = response;
			}

			let all_absences = pending_absences;
			if (page === 0) {
				all_absences = new_absences;
			} else {
				all_absences = pending_absences.concat(new_absences);
			}

			let hasMore = false;
			if (new_absences.length > 0) {
				if (total_items > 0) {
					hasMore = all_absences.length < total_items;
				} else {
					hasMore = new_absences.length === page_size;
				}
			}

			this.setState({
				pending_absences: all_absences,
				isLoading: false,
				hasMore: hasMore,
			});
		} catch (error) {
			console.error("Error fetching pending absences:", error);
			this.setState({
				isLoading: false,
				hasMore: false,
			});
		}
	}

	onDatesChange = (dates) => {
		var { startDate, endDate } = dates;

		if (startDate) startDate = startDate.format("YYYY-MM-DD");

		if (endDate) {
			endDate = endDate.format("YYYY-MM-DD");
		}

		this.setState(
			{
				page: 0, // reset pagination
				start_from: startDate,
				start_to: endDate,
				pending_absences: [],
				hasMore: true,
			},
			async () => {
				await this.getPendingAbsences();
			}
		);
	};

	handleChangeSearch = (event) => {
		const target_id = event.target.id;

		this.setState(
			{
				[target_id]: event.target.value,
				page: 0,
				pending_absences: [],
				hasMore: true,
			},
			async () => {
				await this.getPendingAbsences();
			}
		);
	};

	handleEmployeeFilterChange = (idOrNull) => {
		const employee_id =
			idOrNull === null || idOrNull === undefined || idOrNull === ""
				? -1
				: Number(idOrNull);
		this.setState(
			{
				employee_id,
				page: 0,
				pending_absences: [],
				hasMore: true,
			},
			async () => {
				await this.getPendingAbsences();
			}
		);
	};

	closeModal() {
		this.props.hideModal();
	}

	openNewAbsenceModal() {
		this.props.showModal(
			{
				open: true,
				title: this.props.t("absences.form.newAbsence"),
				style: { width: "430px" },
				content: <AbsenceEditModal handleClose={this.closeModal} />,
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openEditAbsenceModal(absence, disabled) {
		this.props.showModal(
			{
				open: true,
				title: disabled ? this.props.t("absences.viewAbsence") : this.props.t("absences.editAbsence"),
				style: { width: "430px" },
				content: (
					<AbsenceEditModal
						absence={absence}
						disabled={disabled}
						refreshData={() =>
							new Promise((resolve) => {
								this.setState(
									{ page: 0, pending_absences: [], hasMore: true },
									async () => {
										await this.getPendingAbsences();
										resolve();
									}
								);
							})
						}
						handleClose={this.closeModal}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	openAlertModal(message, title) {
		this.props.showModal(
			{
				open: true,
				title: title || this.props.t("common.error"),
				style: { width: "400px" },
				message: message,
				closeModal: this.closeModal,
			},
			"alert"
		);
	}

	openAnswerModal = (absence, onSubmit) => {
		this.props.showModal(
			{
				open: true,
				title: `${this.props.t("absences.approve")} / ${this.props.t("absences.deny")}`,
				style: { width: "500px", maxWidth: "calc(100vw - 32px)" },
				content: (
					<AbsenceAnswerModal
						absence={absence}
						onSubmit={onSubmit}
						handleClose={this.closeModal}
					/>
				),
				closeModal: this.closeModal,
			},
			"edit"
		);
	};

	handleCancelRequest(absence) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t("absences.cancelAbsence"),
				style: { width: "350px" },
				message:
					this.props.t("absences.cancelAbsenceConfirm"),
				deleteAction: () => this.confirmCancelRequest(absence),
				closeModal: this.closeModal,
			},
			"delete"
		);
	}

	confirmCancelRequest = async (absence) => {
		absence.status = wfStatus.canceled;
		absence.shift_id = absence.shift.id;

		if (!this.state.isSubmit) {
			this.setState({ isSubmit: true });
			const response = await workflowsService.update(absence);
			this.setState({ isSubmit: false });

			// console.log(response);
			if (response.ok) {
				toastr.success(this.props.t("common.success"), this.props.t("common.changesSaved"));
				this.setState({ page: 0, pending_absences: [], hasMore: true }, () => {
					this.getPendingAbsences();
				});
				this.closeModal();
			} else {
				if (
					response.errors !== undefined &&
					Object.keys(response.errors).length > 0
				) {
					let textError = response.errors[0].description;
					this.openAlertModal(textError, this.props.t("absences.errorCancelling"));
				} else {
					this.openAlertModal(this.props.t("common.errorGeneric"), this.props.t("absences.errorCancelling"));
				}
			}
		}
	};

	// exportar

	openExportAbsencesModal(token) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t("absences.exportAbsences"),
				style: { width: "400px" },
				confirmText: this.props.t("common.download"),
				loadingText: this.props.t("common.downloading"),
				message:
					this.props.t("absences.exportSuccess"),
				closeModal: this.closeModal,
				confirmAction: () => {
					this.props.updateModalLoading(true);
					this.downloadExport(token, "ausencias.xlsx");
				},
			},
			"confirm"
		);
	}

	async handleExportAbsences(workflow_status) {
		const { start_to, start_from, employee_id, include_all_company } =
			this.state;

		// Aprobado,Denegado (Gestionadas)  / Pendiente (Pendientes)
		const options = {
			workflow_status,
			start_to,
			start_from,
			employee_id,
		};

		if (isAdmin() && isSupervisor()) {
			options.include_all_company = include_all_company;
		}

		const token = await workflowsService.exportWorkflows(options);

		if (token.ok) {
			this.openExportAbsencesModal(token.access_token);
		} else {
			this.openAlertModal(
				this.props.t("absences.errorExporting"),
				this.props.t("absences.errorExportingTitle")
			);
		}
	}

	async downloadExport(token, filename) {
		const response = await appService.getExported(token);
		var url = window.URL.createObjectURL(response);
		var a = document.createElement("a");
		document.body.appendChild(a);
		a.href = url;
		a.download = filename;
		a.click();

		this.props.updateModalLoading(false); // Cambiar a no cargando
		this.closeModal(); // cerrar modal de confirmación
	}

	reloadAbsences = () => {
		this.setState({ page: 0, pending_absences: [], hasMore: true }, () => {
			this.getPendingAbsences();
		});
	};

	handleSwitch = (event) => {
		const targetId = event.target.id;
		this.setState(
			{
				page: 0, // reset pagination
				[targetId]: event.target.checked,
				pending_absences: [],
				hasMore: true,
			},
			() => {
				this.getPendingAbsences();
			}
		);
	};

	getContent = () => {
		if (this.state.isLoading && this.state.page === 0) {
			return <Loading />;
		}

		// if (!this.props.employee_absences) {
		// 	return "Error cargando las ausencias";
		// }

		const { pending_absences, hasMore } = this.state;

		let first_steps = "";

		if (pending_absences.length === 0 && !this.state.isLoading) {
			const step_text =
				this.props.t("absences.firstStepsAdmin");

			first_steps = (
				<div className="first-steps">
					<FiExternalLink className="icono-pasos" />
					<h3 className="title2">{this.props.t("absences.firstStepsTitle")}</h3>

					<p>
						{step_text} {this.props.t("absences.firstStepsLink")}{" "}
						<a className="alink" target="_blank" href={helpUrls.absence}>
							{helpUrls.absence}
						</a>
					</p>
				</div>
			);
		}

		return (
			<>
				{first_steps}
				<InfiniteScroll
					dataLength={pending_absences.length}
					next={this.fetchMoreData}
					hasMore={hasMore}
					loader={
						<div style={{ textAlign: "center", padding: "10px" }}>
							Loading...
						</div>
					}
					endMessage={
						pending_absences.length > 0 && (
							<p
								className="no-more-results"
								style={{ textAlign: "center", padding: "10px" }}
							>
								{this.props.t("absences.noMorePending")}
							</p>
						)
					}
				>
					<PendingAbsences
						pending_absences={pending_absences}
						is_list_view={this.state.is_list_view}
						openEditAbsenceModal={this.openEditAbsenceModal}
						openAnswerModal={this.openAnswerModal}
						openAlertModal={this.openAlertModal}
						reloadAbsences={this.reloadAbsences}
					/>
				</InfiniteScroll>
			</>
		);
	};

	render() {
		return (
			<>
				<Layout className="page-absences page-absences-pending" context="absences">
					<div className="heading">
						<h1 className="title">{this.props.t("absences.pendingTitle")}</h1>

						<div className="heading-actions">
							{isAdmin() && isSupervisor() && (
								<div className="flex-center mr10 pending-show-all">
									<span className="mr10">{this.props.t("absences.showAllRequests")}</span>
									<Switch
										isOn={this.state.include_all_company}
										handleToggle={this.handleSwitch}
										controlId="include_all_company"
									/>
								</div>
							)}

							<FormGroup
								className="form-group form-select-user mr10 pending-employee-filter"
								controlId="employee_id"
							>
								<EmployeeSelectSearch
									className="form-select-user"
									controlId="employee_id"
									multiple={false}
									value={
										this.state.employee_id === -1
											? null
											: String(this.state.employee_id)
									}
									onChange={this.handleEmployeeFilterChange}
									fetchOptions={this.employeeSelectFetchOptions}
									placeholder={this.props.t("common.searchEmployee")}
									allLabel={this.props.t("common.searchEmployee")}
								/>
							</FormGroup>

							<div className="pending-date-filter">
								<DateRangePicker
									startDateId="startDateId"
									endDateId="endDateId"
									startDate={
										this.state.start_from ? moment(this.state.start_from) : null
									}
									endDate={
										this.state.start_to ? moment(this.state.start_to) : null
									}
									startDatePlaceholderText={this.props.t("common.from")}
									endDatePlaceholderText={this.props.t("common.to")}
									onDatesChange={this.onDatesChange}
									focusedInput={this.state.focusedInput}
									hideKeyboardShortcutsPanel={true}
									isOutsideRange={() => false}
									minimumNights={0}
									onFocusChange={(focusedInput) =>
										this.setState({ focusedInput })
									}
								/>
							</div>

							<ButtonGroup
								className="managed-view-toggle"
								aria-label="Absences view"
							>
								<Button
									variant={`${this.state.is_list_view ? "primary" : "default"}`}
									onClick={() => this.handleChangeView(true)}
								>
									<FiList className="icon" />
								</Button>
								<Button
									variant={`${!this.state.is_list_view ? "primary" : "default"}`}
									onClick={() => this.handleChangeView(false)}
								>
									<FiGrid className="icon" />
								</Button>
							</ButtonGroup>

							<button
								type="button"
								title={this.props.t("absences.createAbsence")}
								onClick={this.openNewAbsenceModal}
								className="btn btn-new"
							>
								<FiPlus />
							</button>

							<Dropdown>
								<Dropdown.Toggle variant="action">
									<FiMoreHorizontal />
								</Dropdown.Toggle>
								<Dropdown.Menu>
									<Dropdown.Item
										as="button"
										onClick={() => this.props.history.push("/absences/import")}
									>
										<FiDownload /> {this.props.t("absences.importAbsences")}
									</Dropdown.Item>

									<Dropdown.Item
										as="button"
										onClick={() => this.handleExportAbsences(wfStatus.pending)}
									>
										<FiUpload className="dropdown-icon" /> {this.props.t("absences.exportAbsences")}
									</Dropdown.Item>
								</Dropdown.Menu>
							</Dropdown>
						</div>
					</div>

					{this.getContent()}
				</Layout>

				<Modal hideModal={this.props.hideModal} />
			</>
		);
	}
}

const mapStateToProps = (reducers) => {
	return {
		...reducers.shiftsReducer,
		...reducers.workflowsReducer,
		...reducers.employeesReducer,
		user: reducers.authReducer.user,
		loading: reducers.workflowsReducer.loading,
	};
};

const mapDispatchToProps = (dispatch) => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }));
	},
	updateModalLoading: (isLoading) => dispatch(updateModalLoading(isLoading)),
	getEmployeeAbsences: (employee_id) =>
		dispatch(employeesActions.getEmployeeAbsences(employee_id)),
	getEmployeeAbsenceCalendar: (employee_id, year) =>
		dispatch(employeesActions.getEmployeeAbsenceCalendar(employee_id, year)),
	getPendingAbsences: (options) =>
		dispatch(workflowsActions.getPendingAbsences(options)),
	getManagedAbsences: (options) =>
		dispatch(workflowsActions.getManagedAbsences(options)),
	getAbsenceShifts: (options) => dispatch(shiftsActions.getAllShifts(options)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(AbsencesPending));
